import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { SharedService } from 'app/shared/shared.service';
import { CheckAvailabilityService } from 'app/check-availability/check-availability.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
  selector: 'app-esiid-search',
  templateUrl: './flag-search.component.html',
  styleUrls: ['./flag-search.component.css']
})
export class FlagSearchComponent implements OnInit {

  serviceAddressFormControl = new FormControl('');
  //serviceAddressFormControl = new FormControl('', [Validators.required]);
  apartmentFormControl = new FormControl('', [Validators.required]);

  public service_address_search = {
    "text" : ""
  };
  public service_address_array = [];
  public is_component_load: boolean;
  public is_error_address: boolean;
  public show_advanced_search : boolean;
  public is_error_address_yellow: boolean;
  public is_apt_exist: boolean;
  public is_multiple: boolean;
  public duns: string;
  public tdu: string;
  public tdus: Object;
  public error_address: string;
  public error_address_yellow: string;
  public is_btn_enable: boolean;
  public which_event: string;
  public search_val: any;
  public apt_unit: string;
  public apt_units: any = [];
  public apartment_list: any = [];
  public esiid: string;
  public apartment_obs: Observable<string[]>;
  public old_key: number;
  public showAddressItems: boolean = false;
  public showAptItems: boolean = false;

  public searchResult = {}
  public hasSearchResult : boolean = false;
  public isResultError : boolean = false;
  public ESIID_REGEX = /^[0-9]+$/;
  public esiInputError : boolean = false;
  public displayRemoveHoldSuccess : boolean = false;
  public displayRemoveHoldFail : boolean = false;
  public displayAddHoldSuccess : boolean = false;
  public displayAddHoldFail : boolean = false;
  public isSuperAdmin: boolean;
  private screen: string = 'flag_search';
  public status: string = undefined;

  constructor( private sharedService: SharedService,
               private service: CheckAvailabilityService,
               private dialog : MatDialog,
               private localStorageService: LocalStorageService) {
      this.sharedService.setHeaderTitle(this.screen);
      this.sharedService.IsTheSessionValid(this.screen, true);
    }

  showAdvancedSearch() {
    this.show_advanced_search = true;
  }

  ngOnInit() {
    this.serviceAddressFormControl.valueChanges.subscribe(searchKey => {
      this.clearResultState();
      this.is_error_address_yellow = false;
      this.is_error_address = false;
      this.isSuperAdmin = this.localStorageService.get('isSuperAdmin');


      if (searchKey != undefined && searchKey.trim() != '') {
        this.service.direct_search(searchKey)
          .then((res) => {
            this.service_address_array = [];
            if(res != undefined && res["value"] != undefined && res["value"].length > 0){
              this.service_address_array = res["value"];
            }
            setTimeout(() => {
              this.showAddressItems = this.service_address_array.length > 0 && !this.isInAddressArray(searchKey);
            }, 100);
            if (this.service_address_array.length == 0) {
              this.is_error_address_yellow = true;
              this.is_btn_enable = false;
            }
          });
      } else {
        this.service_address_array = [];
        this.showAddressItems = false;
      }
    });
  }

  get_service_array(options: any[]) {
    let service_array = [];
    for (let i = 0; i < options.length; i++) {
      let opt = options[i];
      let ser_opt = {
        text: this.get_high_suggest(opt._source.suggest),
        _id: opt._source.objectid
      };
      service_array.push(ser_opt);
    }

    return service_array;
  }

  get_high_suggest(suggests: any[]) {
    let text = "";
    let maxLength = 0;
    for (let i = 0; i < suggests.length; i++) {
      let segg = suggests[i];
      if (segg.weight == 3) {
        return segg.input;
      }
    }
  }

  getAddressWithoutApt(address: string) {
    let address_part = address.split(",");
    let new_address = "";
    if (address_part != null && address_part.length > 5) {
      new_address = address_part[0] + "," + address_part[1] + "," + address_part[3] + "," + address_part[4] + "," + address_part[5]
    } else {
      new_address = address;
    }

    return new_address
  }

  addressEvent(event_value_pass: string) {
    this.is_error_address = false;
    this.is_error_address_yellow = false;
    this.is_apt_exist = false;
    this.is_btn_enable = false;
    this.apt_unit = '';
    this.esiid = '';
    this.apartment_list = [];
    let event_value: string;

    event_value = event_value_pass;

    let address_hash = this.getHashFromAddress(event_value);
    const context = this;

    if (address_hash != undefined && address_hash.trim() != '') {
      this.selectAddressHash(address_hash);
    } else {
      if (event_value != undefined && event_value.trim() != '' && this.service_address_array.length == 0) {
        this.is_error_address_yellow = true;
        this.is_btn_enable = false;
      }
    }
  }

  getHashFromAddress(address) {
    for (let i = 0; i < this.service_address_array.length; i++) {
      let service_address = this.service_address_array[i];
      if (service_address["address_full"].trim() == address.trim()) {
        return service_address["FullAddressHashKey"];
      }
    }
    return "";
  }


  aptUnitEvent(event) {
    const enter_key = event.keyCode || event.which;

    if (event.type === 'keyup' && (enter_key === 13) || (this.old_key === 17 && enter_key === 86) ||
      (this.old_key === 86 && enter_key === 17)) {
      this.invokeElementMethod('apartment', 'blur');
    }
    this.old_key = enter_key;
  }

  focusoutServiceAddress(service_address_search_text) {
    this.service_address_search["text"] = service_address_search_text;

    const context = this;
    setTimeout(() => {
      context.showAddressItems = false;
      let element = document.getElementById('service_address_id');
      if (element != undefined) {
        element.blur();
      }
    }, 200);

    this.addressEvent(service_address_search_text);
  }

  isInAddressArray(key: string) {
    let inArray: boolean = false;
    for (let i = 0; i < this.service_address_array.length; i++) {
      let arr_ele = this.service_address_array[i];
      if(arr_ele["address_full"].trim() == key.trim()){
        inArray = true;
        break;
      }
    }
    return inArray;
  }

  isInAPtArray(key: string) {
    let inArray: boolean = false;
    for (let i = 0; i < this.apartment_list.length; i++) {
      let arr_ele = this.apartment_list[i];
      if (arr_ele.toString().trim() == key.trim()) {
        inArray = true;
        break;
      }
    }
    return inArray;
  }

  selectAddressHash(address_hash: string) {
    if (address_hash != undefined && address_hash.trim() != '') {
      this.sharedService.setLoader(this.screen, true);
      if (address_hash.trim().length > 5) {
        let requestObj = {
          'addressHash': address_hash.trim()
        };

        this.service.GetServiceAddressesByHash(requestObj)
          .then(res => {
            this.sharedService.setLoader(this.screen, false);
            if (res.result.length > 0) {
              this.apt_units = res.result;
              for (let i = 0; i < this.apt_units.length; i++) {
                if (this.apt_units[i].aptUnit != null && this.apt_units[i].aptUnit !== '') {
                  let apartment: string = this.apt_units[i].aptUnit;
                  if (apartment.includes(' ')) {
                    apartment = apartment.substring(apartment.indexOf(' ')+1).replace('-','');
                  }
                  this.apartment_list.push(apartment);
                }
              }

              this.is_apt_exist = this.apartment_list.length > 0;
              this.apartment_obs = this.apartmentFormControl.valueChanges.startWith(null).map(val => val ? this.filter(val) : this.apartment_list.slice());
              this.showAptItems = true;
              if (res.result.length === 1) {
                const address_obj = res.result[0];
                if (this.is_apt_exist) {
                  this.apt_unit = this.apartment_list[0];
                  this.chooseApartUnit(this.apt_unit, undefined);
                } else {
                  this.is_btn_enable = true;
                  this.chooseApartUnit('', address_obj);
                  this.invokeElementMethod('home_next', 'focus');
                }
              } else if (this.is_apt_exist) {
                if (this.apartment_list.length == 1) {
                  this.apt_unit = this.apartment_list[0];
                  this.chooseApartUnit(this.apt_unit, undefined);
                } else {
                  const context = this;
                  setTimeout(() => {
                    context.invokeElementMethod('apartment', 'focus');
                  }, 100);
                }
              }

            } else {
              var dataLayerEvent = 'enroll - step 0: address issue';
              (window as any).dataLayer.push({ 'event': dataLayerEvent, 'error address_hash': address_hash.trim() });
              this.is_error_address_yellow = true;
              this.error_address_yellow = this.sharedService.getErrorMessage('address_not_found');
              this.is_btn_enable = false;
            }
          });
    }
    } else {
      this.is_btn_enable = false;
    }
  }

  filter(val: string): string[] {
    setTimeout(() => {
      this.is_btn_enable = false;
      let isInApt: boolean = this.isInAPtArray(val);
      this.showAptItems = this.apartment_list.length > 0 && !this.is_btn_enable;
      if (isInApt) {
        this.chooseApartUnit(this.apt_unit, '');
      }
    }, 100);
    return this.apartment_list.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }

  invokeElementMethod(elementId, method) {
    let element = document.getElementById(elementId);
    if (element !== undefined) {
      if (method.trim() === 'focus') {
        element.focus();
      } else if (method.trim() === 'blur') {
        element.blur();
      } else if (method.trim() === 'click') {
        element.click();
      }
    }
  }

  chooseApartUnit(apt_number: string, address_obj: any) {
    this.clearResultState();
    if ((apt_number == undefined || apt_number.trim() == '') && (address_obj == undefined)) {
      return;
    }
    this.showAptItems = false;
    if (apt_number !== '') {
      for (let i = 0; i < this.apt_units.length; i++) {
        let apartment = this.apt_units[i].aptUnit;
        if (apartment != null) {
          if (apartment.includes(' ')) {
            apartment = apartment.substring(apartment.indexOf(' ')+1).replace('-','')
          }
        }

        if (apartment === apt_number) {
          address_obj = this.apt_units[i];
          this.apt_unit = apartment;
        }
      }
    }

    this.invokeElementMethod('home_next', 'focus');

    this.duns = address_obj.duns;
    this.esiid = address_obj.esiId;

    this.sharedService.validateAddress({ 'ercotId': address_obj.id })
      .then(res => {
        if (res.status === 'success') {
          this.is_error_address = false;
          this.is_error_address_yellow = false;
          this.is_btn_enable = true;
          if (address_obj.aptUnit != null && address_obj.aptUnit !== '') {
            this.is_apt_exist = true;
          }
        } else {
          if (res.color === 'yellow') {
            this.is_error_address_yellow = true;
            this.error_address = res.message;
          } else {
            this.is_error_address = true;
            this.error_address = res.message;
          }
          this.is_btn_enable = false;
        }
      });
  }

  serviceFocusout(event:any)
  {
    let event_value: string = event.target.value;
    event_value = event.target.value;
    this.is_error_address = false;
    this.is_error_address_yellow = false;
    this.is_apt_exist = false;
    this.is_btn_enable = false;
    this.apt_unit = '';
    this.esiid = '';
    this.apartment_list = [];


    let address_hash = this.getHashFromAddress(event_value);
    const context = this;

    if (address_hash != undefined && address_hash.trim() != '') {
      this.selectAddressHash(address_hash);
    } else {
      if (event_value != undefined && event_value.trim() != '' && this.service_address_array.length == 0) {
        this.is_error_address_yellow = true;
        this.is_btn_enable = false;
        this.selectAddressHash(event_value);
      }
    }
  }

  validateEsiIdInput(event){
    this.clearResultState();
    if(event.target.value != ""
        && event.target.value.match(this.ESIID_REGEX)
        && event.target.value.length >= 11
        && event.target.value.length <= 22){
      this.is_btn_enable = true;
      this.esiInputError = false;
    }
    else{
      this.is_btn_enable = false;
      if(event.target.value != ""){
        this.esiInputError = true;
      }
      else
	  {
        this.esiInputError = false;
      }
    }
  }

  searchByEsiId(){
    this.sharedService.setLoader(this.screen, true);
    this.sharedService.flagSearch(
      {
        'EsiId' : this.esiid,
        'Token' : this.localStorageService.get('agentToken')
      })
      .then(res => {
        this.sharedService.setLoader(this.screen, false);
          this.hasSearchResult = true;
          this.isResultError = false;
          this.searchResult = {
            ...res
          };
      })
      .catch(err => {
        this.sharedService.setLoader(this.screen, false);
        this.hasSearchResult = true;
        this.isResultError = true;

      });
  }

	removeERCOTSH() {
		this.sharedService.setLoader(this.screen, true);
		this.sharedService.removeErcotSwitchHold(
			{
				'EsiId': this.esiid,
				'Token': this.localStorageService.get('agentToken')
			})
			.then(res => {
				console.log('res: ', res.isSuccess)
				this.sharedService.setLoader(this.screen, false);
				if (res && res.isSuccess) {
					this.status = 'Successfully removed Switch Hold for ESIID: ' + this.esiid;
				} else {
					this.status = 'Failed to remove Switch Hold for ESIID: ' + this.esiid;
				}
			})
			.catch(err => {
					this.sharedService.setLoader(this.screen, false);
				this.status = 'Failed to remove Switch Hold for ESIID: ' + this.esiid;
				}
			);
	}

  clearForm(){
    this.esiid = '';
    this.apt_unit = '';
    this.is_error_address = false;
    this.is_error_address_yellow = false;
    this.search_val = '';
  }

  removeHold(){
    const dialogRef = this.dialog.open(RemoveEsiIdHold);
    dialogRef.afterClosed().subscribe(result => {
      if(result.status){
        this.sharedService.setLoader(this.screen, true);
        this.displayAddHoldFail = false;
        this.displayAddHoldSuccess = false;

        this.sharedService.removeEsiIdHold(
          {
            'EsiId' : this.esiid,
            'Token' : this.localStorageService.get('agentToken')
          })
          .then(res => {
            this.sharedService.setLoader(this.screen, false);
            this.displayRemoveHoldSuccess = true;
            this.displayRemoveHoldFail = false;
            this.searchResult["isFlagOverridden"] = true;
          })
          .catch(err => {
            this.sharedService.setLoader(this.screen, false);
            this.displayRemoveHoldFail = true;
            this.displayRemoveHoldSuccess = false;
          })
      }
    })
  }

  addHold(){
    const dialogRef = this.dialog.open(AddEsiIdHold);
    dialogRef.afterClosed().subscribe(result => {
      if(result.status){
        this.sharedService.setLoader(this.screen, true);
        this.displayRemoveHoldFail = false;
        this.displayRemoveHoldSuccess = false;

        this.sharedService.addEsiIdHold(
          {
            'EsiId' : this.esiid,
            'Token' : this.localStorageService.get('agentToken')
          })
          .then(res => {
            this.sharedService.setLoader(this.screen, false);
            this.displayAddHoldSuccess = true;
            this.displayAddHoldFail = false;
            this.searchResult["isFlagOverridden"] = false;
          })
          .catch(err => {
            this.sharedService.setLoader(this.screen, false);
            this.displayAddHoldFail = true;
            this.displayAddHoldSuccess = false;
          })
      }
    })
  }

  clearResultState(){
    this.displayRemoveHoldSuccess = false;
    this.displayRemoveHoldFail = false;
    this.displayAddHoldSuccess = false;
    this.displayAddHoldFail = false;
    this.hasSearchResult = false;
    this.isResultError = false;
  }

}

@Component({
  selector: 'remove-esiid-hold',
  template: '<div class="dialog-main" style="text-align:center"><p>Agent action is to inform the customer that the hold has been released and that they can move forward with enrollment via the options.</p><button mat-button class="double-block-btn" (click)="confirm()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Confirm</button><button mat-button class="double-block-btn" (click)="cancel()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Cancel</button></div>'
})
export class RemoveEsiIdHold{
  constructor(public dialogRef: MatDialogRef<RemoveEsiIdHold>){}

  cancel(){
    this.dialogRef.close({'status' : false});
  }

  confirm(){
    this.dialogRef.close({'status' : true});
  }

}

@Component({
  selector: 'add-esiid-hold',
  template: '<div class="dialog-main" style="text-align:center"><p>You are about to add back a ESI ID hold which would prevent enrollment. Are you sure this what you want to do?</p><button mat-button class="double-block-btn" (click)="confirm()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Confirm</button><button mat-button class="double-block-btn" (click)="cancel()" style="width:50%;display: inline-block;border-bottom-right-radius: 7px;">Cancel</button></div>'
})
export class AddEsiIdHold{
  constructor(public dialogRef: MatDialogRef<AddEsiIdHold>){}

  cancel(){
    this.dialogRef.close({'status' : false});
  }

  confirm(){
    this.dialogRef.close({'status' : true});
  }

}






// WEBPACK FOOTER //
// ./src/app/agent/agent-dashboard/flag-search/flag-search.component.ts